import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";
import Button from "../../components/Button/Button.jsx";

import actions from "../../store/actions.js";
import { APP_ROUTES } from "../../router";

const FinishBusiness = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const { mobileConnectionInfo } = useSelector(state => state);

  const redirectAndResetData = () => {
    dispatch(actions.removeData());

    const { refUserId } = mobileConnectionInfo;
    if (refUserId.length > 1) {
      history(`${APP_ROUTES.MOBILE_CONNECTION.START_ROUTE}/${refUserId}`);
    } else {
      history(`${APP_ROUTES.MOBILE_CONNECTION.START_ROUTE}`);
    }
  };

  return (
    <>
      <WrapperContainer gap="16" title="sm">
        Уфанет для Бизнеса
      </WrapperContainer>

      <WrapperContainer gap="24" text="lg">
        Ваша заяка отправлена. Скоро с вами свяжется наш менеджер для уточнения деталей
      </WrapperContainer>

      <Button isStretch color="primary" onClick={redirectAndResetData}>
        Далее
      </Button>
    </>
  );
};

export default FinishBusiness;
